module.exports = __webpack_public_path__ + "static/media/lg-anonymous.1b97fcfb.svg";